/**
 * Levée par un transport de média quand une publication a dû quitter la salle
 * pour qu'une autre la remplace — une caméra qui change de sujet, un micro qui
 * change de profil —, et que la nouvelle n'a pas pu y entrer : plus rien n'est
 * publié.
 *
 * Distinguée d'un échec ordinaire, où la publication d'avant reste en place : le
 * moteur éteint alors ce qu'il croyait encore en salle, plutôt que de laisser un
 * voyant allumé et un aperçu affiché pour une piste que personne ne reçoit.
 */
export class PublicationLostError extends Error {
  constructor(cause: unknown) {
    super("La publication précédente a quitté la salle, et la nouvelle n'a pas pu y entrer.", { cause });
    this.name = "PublicationLostError";
  }
}
